import { types, actions } from './requests'
export const GETPRODUCTRECAP_TYPES = {
    ...types('GETPRODUCTRECAP'),
}
export const GETPRODUCTRECAP_ACTIONS = {
    ...actions('GETPRODUCTRECAP'),
}
